import { render, staticRenderFns } from "./component-customer.vue?vue&type=template&id=9738d172&scoped=true&"
import script from "./component-customer.vue?vue&type=script&lang=js&"
export * from "./component-customer.vue?vue&type=script&lang=js&"
import style0 from "./component-customer.vue?vue&type=style&index=0&id=9738d172&prod&lang=less&scoped=true&"
import style1 from "./component-customer.vue?vue&type=style&index=1&id=9738d172&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9738d172",
  null
  
)

export default component.exports